import { Route } from '@angular/router';
import { adminAuthGuard } from '@sgm-frontend/core';
import { LayoutComponent } from './components/layout/layout.component';

export const appRoutes: Route[] = [
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.routes').then((m) => m.authRoutes)
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [adminAuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent)
      },
      {
        path: 'products',
        loadChildren: () =>
          import('./pages/products/products.routes').then((m) => m.productsRoutes)
      },
      {
        path: 'categories',
        loadChildren: () =>
          import('./pages/categories/categories.routes').then((m) => m.categoriesRoutes)
      },
      {
        path: 'attributes',
        loadChildren: () =>
          import('./pages/attributes/attributes.routes').then((m) => m.attributesRoutes)
      },
      {
        path: 'brands',
        loadChildren: () =>
          import('./pages/brands/brand.routes').then((m) => m.brandsRoutes)
      },
      {
        path: 'tags',
        loadChildren: () =>
          import('./pages/tags/tags.routes').then((m) => m.tagsRoutes)
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./pages/users/users.routes').then((m) => m.usersRoutes)
      },
      {
        path: 'catalogue-import',
        loadComponent: () =>
          import('./components/catalogue-import/catalogue-import.component').then((m) => m.CatalogueImportComponent)
      },
      {
        path: 'coupons',
        loadChildren: () =>
          import('./pages/coupons/coupons.routes').then((m) => m.couponsRoutes)
      },
      {
        path: 'marketing/deals',
        loadChildren: () =>
          import('./pages/deals/deals.routes').then((m) => m.dealsRoutes)
      },
      {
        path: 'seo',
        loadChildren: () =>
          import('./pages/marketing/marketing.routes').then((m) => m.marketingRoutes)
      },
      {
        path: 'marketing',
        loadChildren: () =>
          import('./pages/marketing/marketing.routes').then((m) => m.marketingRoutes)
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./pages/profile/profile.routes').then((m) => m.profileRoutes)
      },
      {
        path: 'orders/cancellations',
        loadChildren: () =>
          import('./pages/cancellations/cancellations.routes').then((m) => m.CancellationsRoutes)
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./pages/orders/manualorder.routes').then((m) => m.ManualorderRoutes)
      },
      // {
      //   path: 'returns',
      //   loadChildren: () =>
      //     import('./pages/returns/returns.routes').then((m) => m.ReturnsRoutes)
      // },
      {
        path: 'media',
        loadChildren: () =>
          import('./pages/media/media.routes').then((m) => m.MediaRoutes)
      },
      {
        path: 'performance',
        loadChildren: () =>
          import('./pages/performance/performance.routes').then((m) => m.PerformanceRoutes)
      },
      {
        path: 'reviews',
        loadChildren: () =>
          import('./pages/reviews/reviews.routes').then((m) => m.reviwsRoutes)
      },
      {
        path: 'wishlist',
        loadChildren: () =>
          import('./pages/wishlist/wishlist.routes').then((m) => m.wishlistRoutes)
      },
      {
        path: 'accounts',
        loadChildren: () =>
          import('./pages/accounts/accounts.routes').then((m) => m.accountsRoutes)
      },
      {
        path: 'notification',
        loadChildren: () =>
          import('./pages/notification/notification.routes').then((m) => m.NotificationsRoutes)
      },
      {
        path: 'user-searches',
        loadChildren: () =>
          import('./pages/user-searches/user-searches.routes').then((m) => m.UserSearchesRoutes)
      },
      {
        path: 'analytics',
        loadChildren: () =>
          import('./pages/analytics/analytics.routes').then((m) => m.analyticsRoutes)
      },
      {
        path: 'shipping',
        loadChildren: () =>
          import('./pages/shipping/shipping.routes').then((m) => m.shippingRoutes)
      },
      {
        path: 'custom',
        loadChildren: () =>
          import('./pages/custom/custom.routes').then((m) => m.customRoutes)
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./pages/settings/settings.routes').then((m) => m.settingsRoutes)
      },
      {
        path: 'finance',
        loadChildren: () =>
          import('./pages/finance/finance.routes').then((m) => m.financeRoutes)
      },
      {
        path: 'marketing/deals',
        loadChildren: () =>
          import('./pages/deals/deals.routes').then((m) => m.dealsRoutes)
      },
      {
        path: 'marketing/coupons',
        loadChildren: () =>
          import('./pages/coupons/coupons.routes').then((m) => m.couponsRoutes)
      },
      {
        path: 'analytics',
        loadChildren: () =>
          import('./pages/analytics/analytics.routes').then((m) => m.analyticsRoutes)
      },
      {
        path: 'system-tools',
        loadChildren: () =>
          import('./pages/system-tools/system-tools.routes').then((m) => m.systemToolsRoutes)
      }
    ]
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then((m) => m.NotFoundComponent)
  }
];
